import { AutocompleteChangeReason } from "@mui/material";
import { FieldProps } from "@rjsf/core";
import { useEffect, useState } from "react";
import { LangPropType } from "../SelectCountry";
// import { languages, Language } from 'countries-list';
import { useTranslations } from "hooks";
import { CountryLangPropType, CountryPropType, useGetCountryLanguage } from "./useGetCountryLanguage";
import _ from "lodash";
// import { useTranslations } from "hooks";
import { languages, Language } from 'countries-list'

export const useSelectCountryLang = (props: FieldProps<CountryLangPropType | undefined>): UseSelectCountryLang => {

    const [value, setValue] = useState(props.formData)
    const [languageOptions, setlanguageOptions] = useState<Array<LangPropType>>()
    const countryOptions = useGetCountryLanguage()
    const languageListTranslated = useTranslations(value?.country?.languageList || []) /* countries_${code}*/
    const defaultListLg = useGetDefaultLanguageList();
    
    useEffect(() => {
        const option = countryOptions?.find((item) => (item.code === props.formData?.country?.code?.toUpperCase()))
        option && setValue((v) => {
            if (option === v?.country) return v
            return ({ ...v, country: option })
        })
    }, [countryOptions, props.formData?.country])

    useEffect(() => {
        if(!languageOptions && (value?.country?.languageList?.length || 0) > 0) {
            setlanguageOptions(getlanguageOptions(value?.country?.languageList, languageListTranslated, defaultListLg));
        }
    }, [languageListTranslated, value?.country?.languageList, languageOptions])

    useEffect(() => {
        const option = languageOptions?.find((item) => (item.code === props.formData?.language?.code.toUpperCase()))
        option && setValue((v) => {
            if (option === v?.language) return v
            return ({ ...v, language: option })
        })
    }, [languageOptions, props.formData?.language])

    useEffect(() => {
        props.onChange?.((_.isEmpty(value?.country?.code) || _.isEmpty(value?.language?.code)) ? undefined : value);
    }, [value])

    const handleChangeCountry = (e: React.SyntheticEvent<Element, Event>, value: CountryPropType | null, reason: AutocompleteChangeReason) => {
        setValue((v) => ({ ...v, country: value || undefined, language: undefined }))
        setlanguageOptions(undefined)
    }

    const handleChangeLanguage = (e: React.SyntheticEvent<Element, Event>, value: LangPropType | null, reason: AutocompleteChangeReason) => {
        setValue((v) => ({ ...v, language: value || undefined }))
    }

    return {
        value,
        countryOptions,
        languageOptions,
        handleChangeCountry,
        handleChangeLanguage
    }
}

type UseSelectCountryLang = {
    value?: CountryLangPropType
    countryOptions?: Array<CountryPropType>
    languageOptions?: Array<LangPropType>
    handleChangeCountry: (e: React.SyntheticEvent<Element, Event>, value: CountryPropType | null, reason: AutocompleteChangeReason) => void
    handleChangeLanguage: (e: React.SyntheticEvent<Element, Event>, value: LangPropType | null, reason: AutocompleteChangeReason) => void
}

const getlanguageOptions = (options: Array<string> = [], languageListTranslated: Array<string> = [], defaultLisLg: Array<LangPropType>): Array<LangPropType> => {
    const lgList = options.map((item: string, key: number) => ({
        name: languageListTranslated[key],
        code: item.split('_')[1].toUpperCase()
    })).filter((lg: LangPropType) => (
        !checkInBlackList(lg.code)
    ));
    const optionsLg = languages as Record<string, Language>;
    const navigatorLg = navigator.language.split('-')[0] ? navigator.language.split('-')[0] : navigator.language;
    const isInBlackList = checkInBlackList(navigatorLg);
    if(lgList.length == 0 && !isInBlackList) {
        // push navigator language
        lgList.push({
            name: optionsLg[navigatorLg.toLowerCase()].native , 
            code: navigatorLg.toUpperCase()
        });
        // push Default list language
        const defaultLisLgfilter = defaultLisLg.filter((item: LangPropType) => (
            item.code.toUpperCase() != navigatorLg.toUpperCase()
        ))
        defaultLisLgfilter && lgList.push(...defaultLisLgfilter)
    }
    return (lgList)
}

const checkInBlackList = (codeLg: string) => {
    return process.env.REACT_APP_LANGUAGE_BLACKLIST?.split(';').find(item => (codeLg.toUpperCase() == item.toUpperCase()))
}

const useGetDefaultLanguageList = () => {
    const DefaultLgList = process.env.REACT_APP_LANGUAGE_DEFAULTLIST?.split(';');
    if(DefaultLgList) {
        const lgListTranslated = useTranslations(
            DefaultLgList.map((item: string) => (
            `language_${item.toLowerCase()}`)
        ))
        return DefaultLgList.map((item: string, key: number) =>(
            {
                name: lgListTranslated[key],
                code: item.toUpperCase()
            }
        ))
    } else {
        return []
    }
}

